// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__EBPPQ","footer":"Layout_footer__K8scF"};